<!--
  a11y: audit reported the POI results page was inaccessible. Each station
  card has a row of bus-line badges (agency logo + route number) which were
  previously rendered as plain <div>s with the agency name on the <img> alt
  and the route number in a separate <span>. SR users would hear two
  disconnected tokens (e.g. "Egged" pause "3") per badge with no clue they
  belonged together. Changes:
   - Wrap the badges in <ul role="list" aria-label="Lines at this station">
     so SR announces the row as a labelled list of items.
   - Each badge is its own <li> with a single aria-label like "Line 3,
     Egged" - the inner <img> is now aria-hidden (the logo is decorative,
     the agency name is conveyed through the parent's aria-label) and the
     route-number <span> is aria-hidden too.
   - The "+N" overflow badge (8th item) gets its own aria-label
     ("N more lines") so SR users know how many extra lines exist.
   - <mat-divider>s are aria-hidden (already implicit, made explicit) - they
     are purely visual separators.
-->
<ul
  role="list"
  class="flex flex-wrap gap-5 items-center justify-center px-3 list-none m-0 p-0"
  [attr.aria-label]="linesAtStationLabel"
>
  @for (route of routes; track route; let i = $index) {
    <li class="flex gap-3 items-center list-none">
      @if (i < 7) {
        <div
          class="flex items-center gap-2 h-[2.5rem] w-[3.8125rem]"
          [attr.aria-label]="getLineBadgeAriaLabel(route)"
          role="group"
        >
          <img
            [src]="route.agencyId | agencyLogo"
            alt=""
            aria-hidden="true"
            class="h-6"
          />
          <span class="bg-gray px-1 py-0.5 rounded text-xs" aria-hidden="true">{{
            route.agencyId === 2 ? route.routeDesc : route.routeName
          }}</span>
        </div>
      }
      @if (i === 7) {
        <span
          class="bg-[#0068F5] px-1 py-0.5 rounded text-xs text-white"
          [attr.aria-label]="getMoreLinesAriaLabel(routes.length - 7)"
          >{{ routes.length - 7 }}+</span
        >
      }
      @if (i < 7 && i < routes.length - 1) {
        <mat-divider vertical="true" class="h-4" aria-hidden="true" />
      }
    </li>
  }
</ul>